exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-f6ea4930]{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.badge.badge-success[data-v-f6ea4930]{background:#00a65a!important}.badge.badge-danger[data-v-f6ea4930]{background:#dd4b39!important}.badge.badge-warning[data-v-f6ea4930]{background:#94cf22}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6ea4930","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/Participants/StatusBadge.vue
// module id = 2114
// module chunks = 1